import { Stack, Text } from "@fluentui/react";
import { useBreakpoint } from "../../../Container/ContainerStyles";
import { BreakpointType } from "../../../Container/ContainerFluid";
import { Col } from "../../../Container/Grid/Col";
import { RegisterTextField } from "../Common/RegisterField";
import { colClass } from "./Styles/RegisterGoalsStyles";
import { Row } from "../../../Container/Grid/Row";
import { containerStyles, formContainerStyles, lgContainerStyles, lgSubTitleStyles, lgTitleContainerStyles, lgTitleStyles, mdContainerStyles, mdSubTitleStyles, mdTitleContainerStyles, mdTitleStyles, smContainerStyles, smSubTitleStyles, smTitleContainerStyles, smTitleStyles, subTitleStyles, titleContainerStyles, titleStyles, xlContainerStyles, xlSubTitleStyles, xlTitleContainerStyles, xlTitleStyles, xxlContainerStyles, xxlSubTitleStyles, xxlTitleContainerStyles, xxlTitleStyles } from "../Common/Styles/CommonStyles";
import { IRegisterContext, useRegisterContext } from "../../RegisterContainer";
import { useEffect, useState } from "react";
import { CrmLostRiskLine } from "../../../LeadDashboard/LeadDashboard";
import { RegisterService } from "../../Service/RegisterService";

export const RegisterGoals: React.FC = () => {
    const registerContext: IRegisterContext = useRegisterContext();
    const [businessNeed1, setBusinessNeed1] = useState<CrmLostRiskLine>(registerContext.leadToLive.leadToLiveQualificationDetails.businessNeedsRiskLines[0]);
    const [businessNeed2, setBusinessNeed2] = useState<CrmLostRiskLine>(registerContext.leadToLive.leadToLiveQualificationDetails.businessNeedsRiskLines[1]);
    const [businessNeed3, setBusinessNeed3] = useState<CrmLostRiskLine>(registerContext.leadToLive.leadToLiveQualificationDetails.businessNeedsRiskLines[2]);

    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    useEffect(() => {
        registerContext.setLeadToLive({
            ...registerContext.leadToLive,
            leadToLiveQualificationDetails: {
                ...registerContext.leadToLive.leadToLiveQualificationDetails,
                businessNeedsRiskLines: [businessNeed1, businessNeed2, businessNeed3]
            }
        });
    },[businessNeed1, businessNeed2, businessNeed3]);
    
    return (
        <Stack
            className={
                isSM ? 
                    smContainerStyles : 
                isMD ? 
                    mdContainerStyles :
                isLG ?
                    lgContainerStyles :
                isXL ?
                    xlContainerStyles :
                isXXL ?
                    xxlContainerStyles
                :
                    containerStyles
            }
        >
            <Stack
                className={
                    isSM ? 
                        smTitleContainerStyles : 
                    isMD ? 
                        mdTitleContainerStyles :
                    isLG ?
                        lgTitleContainerStyles :
                    isXL ?
                        xlTitleContainerStyles :
                    isXXL ?
                        xxlTitleContainerStyles
                    :
                        titleContainerStyles
                }
            >
                <Text 
                    className={
                        isSM ? 
                            smTitleStyles : 
                        isMD ? 
                            mdTitleStyles : 
                        isLG ?
                            lgTitleStyles :
                        isXL ?
                            xlTitleStyles :
                        isXXL ?
                            xxlTitleStyles
                        :
                            titleStyles
                    }
                >
                    {RegisterService.translate("goals:title")}
                </Text>
                <Text 
                    className={
                        isSM ? 
                            smSubTitleStyles : 
                        isMD ? 
                            mdSubTitleStyles :
                        isLG ?
                            lgSubTitleStyles :
                        isXL ?
                            xlSubTitleStyles :
                        isXXL ?
                            xxlSubTitleStyles
                        :
                            subTitleStyles
                    }
                >
                    {RegisterService.translate("goals:description")}
                </Text>
            </Stack>
            <Stack
                className={formContainerStyles}
            >
                <Row>
                    <Col
                        colClass={colClass}
                    >
                        <RegisterTextField 
                            autoFocus 
                            placeholder={RegisterService.translate("goals:goal1")}
                            value={businessNeed1.description}
                            errorMessage={RegisterService.getErrorMessage(registerContext.registerError, 'goals')}
                            onChange={(value) => {
                                setBusinessNeed1({...businessNeed1, description: value});
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col
                        colClass={colClass}
                    >
                        <RegisterTextField 
                            placeholder={RegisterService.translate("goals:goal2")}
                            value={businessNeed2.description}
                            onChange={(value) => {
                                setBusinessNeed2({...businessNeed2, description: value});
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col
                        colClass={colClass}
                    >
                        <RegisterTextField 
                            placeholder={RegisterService.translate("goals:goal3")}
                            value={businessNeed3.description}
                            onChange={(value) => {
                                setBusinessNeed3({...businessNeed3, description: value});
                            }}
                        />
                    </Col>
                </Row>
            </Stack>
        </Stack>
    );
};